import React, { useState } from 'react'
import { ReactComponent as RegionIcon } from "assets/img/svg/GlobeHemisphereWest.svg"
import { ReactComponent as JobIcon } from "assets/img/svg/GraduationCap.svg"
import { ReactComponent as DepartmentIcon } from "assets/img/svg/OfficeChair.svg"
import { ReactComponent as LogsIcon } from "assets/img/svg/HourglassSimpleHigh.svg"
import { Tooltip } from '@mui/material'
import { AGridColDef } from 'views/pages/manage/common/data-grid/ADataGridColDef'
import moment from 'moment'
import { editCellContainerStyle } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant'
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete'
import { endpoint, regex } from '../../../views/pages/manage/common/constant'

export const menuItems = [
  { id: 1, key: 'regionMapping', icon: <RegionIcon />, label: 'Region Mapping', desc: 'Map Phoenix regions to HONO regions' },
  { id: 2, key: 'jobTitleMapping', icon: <JobIcon />, label: 'Job Title Mapping', desc: 'Map Phoenix job titles to HONO' },
  { id: 3, key: 'departmentMapping', icon: <DepartmentIcon />, label: 'Department Mapping', desc: 'Map Phoenix department types to HONO' },
  { id: 4, key: 'logs', icon: <LogsIcon />, label: 'Logs', desc: 'List of changes made' },
];
export const operationTypeMapping = {
  DEPARTMENT_MAPPING_OPERATION:'Department Mapping',
  REGION_MAPPING_OPERATION:'Region Mapping',
  JOBTITLE_MAPPING_OPERATION:'Job Title Mapping'
}

export const getFormatedLastUpdatedOn=(params)=>{
return `${moment(params?.row?.updatedOn).format('DD-MMM-YYYY')}, ${moment(params?.row?.updatedOn).format('hh:mm A')} by ${params?.row?.updatedBy}`
}

const COMMON_COLUMNS = (dropdowns,rowFormHandler,rowForm) => {
  return [
    new AGridColDef("phoenixValueId", "Phoenix Value", false)
      .setMinWidth(100)
      .editable(true)
      .setFlex(2)
      .renderCellComponent((params) => (
        params?.value ? <Tooltip title={params?.value?.label}>
          <div className={`ellipsis-text-container`} >{params?.value?.label}</div>
        </Tooltip> : <div>-</div>
      ))
      .renderEditCellComponent(params => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            currentValue={rowForm?.phoenixValueId}
            handleChange={value => {
              rowFormHandler(value, 'phoenixValueId');
            }}
            items={dropdowns?.phoenixValueId}
            isMulti={false}
            //style={selectStyles}
            placeholder={'Select'}
            autoFocus={params?.hasFocus}
          />
        </div>
      )),
    new AGridColDef("honoValue", "Hono Value", false)
      .setMinWidth(100)
      .editable(true)
      .setFlex(2)
      .renderCellComponent((params) => (
        params?.value ? <Tooltip title={params?.value?.label}>
          <div className={`ellipsis-text-container`} >{params?.value?.label}</div>
        </Tooltip> : <div>-</div>
      ))
      .renderEditCellComponent(params => (
        <div style={editCellContainerStyle}>
          <AAutoComplete
            currentValue={rowForm?.honoValue}
            handleChange={value => {
              rowFormHandler(value, 'honoValue');
            }}
            items={dropdowns?.honoValue}
            isMulti={false}
            //style={selectStyles}
            placeholder={'Select'}
            autoFocus={params?.hasFocus}
          />
        </div>
      )),
    new AGridColDef("updatedOn", "Last updated On", false)
      .setMinWidth(100)
      .editable(false)
      .setFlex(2)
      .renderCellComponent((params) => (
        params?.value ? <Tooltip title={getFormatedLastUpdatedOn(params)}>
          <div className={`ellipsis-text-container`} >{getFormatedLastUpdatedOn(params)}</div>
        </Tooltip> : <div>-</div>
      )),
  ]
}
export const logscolumn=()=>[
 new AGridColDef("operationType", "Type", false)
      .setMinWidth(100)
      .editable(true)
      .setFlex(2)
      .renderCellComponent((params) => (
        params?.value ? <Tooltip title={operationTypeMapping?.[params?.value]}>
          <div className={`ellipsis-text-container`} >{operationTypeMapping?.[params?.value]}</div>
        </Tooltip> : <div>-</div>
      )),
       new AGridColDef("operation", "Event", false)
      .setMinWidth(100)
      .editable(true)
      .setFlex(2)
      .renderCellComponent((params) => (
        params?.value ? <Tooltip title={params?.value}>
          <div className={`ellipsis-text-container`} >{params?.value}</div>
        </Tooltip> : <div>-</div>
      )),
       new AGridColDef("eventMessage", "Value", false)
      .setMinWidth(100)
      .editable(true)
      .setFlex(2)
      .renderCellComponent((params) => (
        params?.value ? <Tooltip title={params?.value}>
          <div className={`ellipsis-text-container`} >{params?.value}</div>
        </Tooltip> : <div>-</div>
      )),
      new AGridColDef("updatedOn", "Last Updated On", false)
      .setMinWidth(100)
      .editable(false)
      .setFlex(2)
      .renderCellComponent((params) => (
        params?.value ? <Tooltip title={getFormatedLastUpdatedOn(params)}>
          <div className={`ellipsis-text-container`} >{getFormatedLastUpdatedOn(params)}</div>
        </Tooltip> : <div>-</div>
      ))
]
export const columns = {
  regionMapping: COMMON_COLUMNS,
  jobTitleMapping: COMMON_COLUMNS,
  departmentMapping: COMMON_COLUMNS,
  logs: logscolumn
}
export const flatMap=Object.fromEntries(menuItems.map(i => [i.key, columns?.[i.key]?.()]))

export const newRow = {
  phoenixValueId: '',
  honoValue: ''
}

export const searchInputOptions = [
      {
        label: 'Phoenix Value',
        keyName: 'phoenixValueDispVal',
        placeholder: 'Search by Phoenix Value',
        errorMsg: 'Please Enter a valid value',
        regex: regex.alphaNumericWithSpaceAndUnderscore,
    },
    {
        label: 'Hono Value',
        keyName: 'honoValue',
        placeholder: 'Search by Hono Value',
        errorMsg: 'Please Enter a valid value',
        regex: regex.alphaNumericWithSpaceAndUnderscore,
    },

]

export const getDropdownFromArrayList=(list=[])=>{
  return list.map(item=>(
    {label:item, value:item}
  ))
}

export const createReqObj=(rowForm)=>{
return {
    phoenixValueId: rowForm?.phoenixValueId?.value,
    phoenixValueDispVal:  rowForm?.phoenixValueId?.label,
    honoValue:  rowForm?.honoValue?.value,

}
}
// const mappingCrudUrl={
//   regionMapping:{
//     search:`${}`,
//     create:`${}`,
//     update:`${}`,
//     delete:`${}`,
//   },
//     jobTitleMapping:{
//     search:`${}`,
//     create:`${}`,
//     update:`${}`,
//     delete:`${}`,
//   },
//     regionMapping:{
//     search:`${}`,
//     create:`${}`,
//     update:`${}`,
//     delete:`${}`,
//   },
//   logs:endpoint.getEmployeeDetailLogs
// }

export const responseListKeyMapping={
  regionMapping:'regionHonoMappingList' ,
  jobTitleMapping:'jobTitleHonoMappingList' ,
  departmentMapping:'departmentHonoMappingList' ,
  logs: 'empoloyeeLogDetailList'
}

